import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import LenderLayout from './layouts/LenderLayout';
import BrokerLayout from './layouts/BrokerLayout';
import LenderDashboardPage from './pages/lender/LenderDashboardPage';
import BrokersListPage from './pages/lender/BrokersListPage';
import BrokerDetailPage from './pages/lender/BrokerDetailPage';
import FeatureManagementPage from './pages/lender/FeatureManagementPage';
import BrokerDashboardPage from './pages/broker/BrokerDashboardPage';
import BrokerPipelinePage from './pages/broker/BrokerPipelinePage';
import BrokerUsersPage from './pages/broker/BrokerUsersPage';
import BrokerOfficesPage from './pages/broker/BrokerOfficesPage';
import CompensationPage from './pages/broker/CompensationPage';
import LoanDetailPage from './pages/broker/LoanDetailPage';
import ScenarioPricerPage from './pages/broker/ScenarioPricerPage';
import BorrowerPortalPage from './pages/public/BorrowerPortalPage';
import { authService } from './services/authService';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<LoginPage />} />
        
        {/* Public Routes */}
        <Route path="/borrower-portal" element={<BorrowerPortalPage />} />
        
        {/* Lender Admin Routes */}
        <Route path="/lender" element={<LenderLayout />}>
          <Route index element={<Navigate to="/lender/dashboard" replace />} />
          <Route path="dashboard" element={<LenderDashboardPage />} />
          <Route path="brokers" element={<BrokersListPage />} />
          <Route path="brokers/:id" element={<BrokerDetailPage />} />
          <Route path="feature-management" element={<FeatureManagementPage />} />
        </Route>

        {/* Broker Routes */}
        <Route path="/broker" element={<BrokerLayout />}>
          <Route index element={<Navigate to="/broker/dashboard" replace />} />
          <Route path="dashboard" element={<BrokerDashboardPage />} />
          <Route path="scenario-pricer" element={<ScenarioPricerPage />} />
          <Route path="pipeline" element={<BrokerPipelinePage />} />
          <Route path="loans/:id" element={<LoanDetailPage />} />
          <Route path="users" element={<BrokerUsersPage />} />
          <Route path="offices" element={<BrokerOfficesPage />} />
          <Route path="compensation" element={<CompensationPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
